/* eslint-disable max-len */
export default {
  ACTIONS: {
    BACK: 'Back',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    COLLECT: 'Collect',
    CONFIRM: 'Confirm',
    NEW_USER: 'New user',
    NEXT: 'Next',
    SAVE: 'Save',
    SCAN_QR_CODE: 'Scan the QR code',
    SWIPE_DOWN: 'Swipe down to hide details',
    SWIPE_UP: 'Swipe up to see details',
    WITHOUT_PIN: 'Don\'t have a PIN or QR code? {link}.',
    WITHOUT_PIN_TO_COLLECT: 'Don\'t have a PIN? {link}'
  },
  ERRORS: {
    INVALID_CODE: 'Invalid code.',
    INVALID_EMAIL: 'Invalid email.',
    INVALID_NUMBER: 'Invalid number.',
    INVALID_PHONE: 'Invalid phone.',
    INVALID_USER: 'Invalid user.',
    ORDER_DELIVER_INVALID_CODE: 'Invalid {code}.',
    ORDER_DELIVERED: 'The order has already been delivered.',
    SOMETHING_WENT_WRONG: 'An error occurred!',
    UNABLE_TO_VALIDATE: 'Unable to validate order.',
    VALIDATING_CODE: 'Unable to validate the {code} code.'
  },
  LABELS: {
    ACCEPT_RETURN: 'Are you sure you want to accept the return?',
    ALL_ORDERS: 'Show all',
    ANOMALY: 'Anomaly?',
    CANCELED: 'Canceled',
    CLICK_HERE: 'Click here',
    CLIENT_NAME: 'Customer',
    COLLECT_ORDER: 'Return order',
    COLLECTS_NOT_FOUND: 'No collections found.',
    CUSTOMER_SIGNATURE: 'Customer signature',
    DATE_AND_HOUR: 'Date & Time',
    DELIVER_ORDER: 'Deliver order',
    DELIVERED: 'Delivered',
    EMAIL: 'Email',
    ERROR: 'Error',
    IDENTITY_DOCUMENT: 'Identity document',
    IDENTITY_NAME: 'Identity document name',
    IDENTITY_NUMBER: 'Identity document number',
    NAME: 'Name',
    NEW_USER: 'New user',
    NO_USERS: 'There is no user yet.',
    NOT_DELIVERED: 'Not delivered',
    OR: 'Or',
    ORDER_CODE: 'Order code',
    ORDER_NUMBER: 'Order no.',
    PACKAGE_NUMBER: 'Package number',
    PACKAGES: 'Packages',
    PACKAGES_CODES: 'Packages codes',
    PACKAGES_DELIVERED: 'Packages delivered',
    PACKAGES_NUMBER: 'No. of packages',
    PACKAGES_RECEIVED: 'Packages received',
    PHONE: 'Phone no.',
    PHONE_EXAMPLE: ', example: +351999999999',
    PICK_UP_COLLECT_PIN: 'Return PIN',
    PICK_UP_NOT_FOUND: 'No pick up point found.',
    PICK_UP_PIN: 'Pick-up PIN',
    PICK_UP_SEARCH: 'Find a pick up point',
    PICK_UP_SELECT: 'Select a pick up point',
    PROCESSING: 'Processing',
    READ_CLIENT_DELIVERY_QR_CODE: 'Read pick up QR code',
    READ_PACKAGE_QR_CODE: 'Read package QR code',
    RECEIVE_PACKAGES: 'Receive packages',
    RECEIVED_BY: 'Received by',
    RETURNED: 'Returned',
    RETURNS: 'Returns',
    SEARCH_FOR: 'Search',
    SELECT_DELIVER: 'Select an order to deliver',
    SHOW_ALL: 'All',
    SHOW_IN_TRANSIT: 'In transit',
    SHOW_PENDING: 'Pending',
    STATE: 'Status',
    SUCCESS: 'Success',
    TOTAL_ORDERS: 'Orders',
    TOTAL_PACKAGES: 'Packages',
    TRACKING_NUMBER: 'Tracking no.',
    TYPE: 'Type',
    TYPE_COLLECT: 'Collection request',
    TYPE_DELIVERY: 'Delivery request',
    USERS: 'Users',
    WARNING: 'Warning',
    YOUR_ID: 'Your ID: {id}'
  },
  SENTENCES: {
    COLLECT_PACKAGES: 'Package(s) of the order {trackingNumber}.',
    DELIVERED_PACKAGES:
      'All packages of the order {trackingNumber} have been read.',
    HI: '👋 Hi, {name},',
    NO_DELIVERIES: 'There are no orders to be delivered.',
    ORDER_TO_RETURN: 'Fill in the PIN of the order to be returned.',
    RECEIVED_PACKAGES: 'All packages have been received.',
    UNDELIVERED_PACKAGES:
      'There are {total} unread package(s) of the order {trackingNumber}.',
    UNRECEIVED_PACKAGES: 'There are {total} unreceived package(s).',
    WELCOME: 'Welcome. What do you want to do?',
    WELCOME_WITH_PROZIS_POINTS:
      'You\'ve already won {prozisPoints} ProzisPoints.',
    WITHOUT_SERVICE_POINTS:
      'There are no service points assigned. The app will now close.'
  },
  SUCCESS: {
    CODE_READ: 'Code {code} read successfully.'
  }
};
